<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h2 class="text-primary" style="margin-bottom: 0px">
          <i class="fas fa-boxes" /> Importação de Contas a receber
        </h2>
      </div>
    </div>

    <hr />
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Enviar planilha do Excel (.xlsx):</label>
          <input
            ref="fileInput"
            type="file"
            class="form-control-file"
            @change="onFileSelected($event)"
          />
        </div>
      </div>
      <div class="col-md-2">
        <button class="btn btn-success" @click="upload">Enviar</button>
      </div>
    </div>
    <hr />
    <button class="btn btn-success" @click="store">Importar</button>
    <div class="row">
      <div class="col-md-12 mt-5">
        <table class="table">
          <tr>
            <th v-for="column in columns">
              {{ column.label }}
            </th>

            <th></th>
          </tr>
          <template v-for="(row, index) in products">
            <tr :key="index">
              <td v-for="column in columns">
                {{ row[column.key] }}
              </td>

              <td>
                <span v-if="isRowValid(row)">Ok</span>
                <span v-else>Erro</span>
              </td>
            </tr>
          </template>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Filters from "./../../mixins/Filters.js";

export default {
  components: {},

  data: function () {
    return {
      form: {},

      products: [],

      //   base_sku_id: {},

      //   description: {},

      //   brand: {},

      //   value: {},

      //   gtin: {}

      columns: [
        { key: "A", label: "Nome" },
        { key: "B", label: "Documento" },
        { key: "C", label: "Descrição" },
        { key: "D", label: "Valor" },
        { key: "E", label: "Vencimento" },
        { key: "F", label: "Compra" },
      ],
    };
  },

  created() {
    //this.$store.commit('pageHasLoaded')
    this.$store.commit("pageHasLoaded");
    // axios
    //   .post("../../api/billpayable/import/loaddata")
    //   .then(response => {
    //     // this.bills        = response.data.bills
    //     // this.account_plan = response.data.accountPlan;
    //     this.bills = response.data[0];
    //     console.log(response.data);
    //   })
    //   .catch(error => {
    //     this.error = error;
    //   });
  },

  methods: {
    isRowValid(row) {
      if (row.C == null) {
        return false;
      }

      return true;
    },

    onFileSelected(event) {
      console.log(event);
      this.form.file = event.target.files[0];
    },

    upload() {
      this.$store.commit("showLoading");

      let form = new FormData();
      form.append("file", this.form.file, "file");

      axios
        .post("./../api/billreceiveble/import", form)
        .then((response) => {
          this.products = response.data;
          console.log(this.products["4"]);
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          console.log(error);
          this.error = error;
          this.$store.commit("hideLoading");
        });
    },

    store() {
      this.$store.commit("showLoading");

      axios
        .post("./../api/billreceiveble/storeimport", this.products)
        .then((response) => {
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          console.log(error);
          this.error = error;
          this.$store.commit("hideLoading");
        });
    },
  },
};
</script>

